import ChatAreaAlert from 'conversations-visitor-experience-components/visitor-widget/ChatAreaAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState } from 'react';
import VizExLink from 'visitor-ui-component-library/link/VizExLink';
import { CREATE_NEW_THREAD_FAILED, CREATE_NEW_THREAD_FAILED_OUTDATED, NETWORK_OFFLINE, PUBSUB_FAILED, SUBSCRIPTIONS_FAILED, THREAD_HISTORY_FAILED } from '../../constants/networkErrors';
import { jsx as _jsx } from "react/jsx-runtime";
const NetworkErrorAlerts = ({
  createNewThread,
  fetchOlderThreadHistory,
  networkError,
  startPubSub,
  resubscribe
}) => {
  const [dismissedNetworkErrors, setDismissedNetworkErrors] = useState([]);
  const dismissNetworkError = () => {
    setDismissedNetworkErrors([...dismissedNetworkErrors, networkError]);
  };
  if (dismissedNetworkErrors.includes(networkError)) {
    return null;
  }
  const title = (() => {
    switch (networkError) {
      case NETWORK_OFFLINE:
      case PUBSUB_FAILED:
      case SUBSCRIPTIONS_FAILED:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.network.offline.title"
        });
      case THREAD_HISTORY_FAILED:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.network.pubSubFailure.title"
        });
      case CREATE_NEW_THREAD_FAILED:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.network.newThreadFailure.title"
        });
      case CREATE_NEW_THREAD_FAILED_OUTDATED:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.network.newThreadFailureOutdated.title"
        });
      default:
        return null;
    }
  })();
  const link = (() => {
    switch (networkError) {
      case THREAD_HISTORY_FAILED:
        return /*#__PURE__*/_jsx(VizExLink, {
          use: "on-bright",
          onPress: fetchOlderThreadHistory,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-visitor-ui.network.pubSubFailure.retry"
          })
        });
      case CREATE_NEW_THREAD_FAILED:
        return /*#__PURE__*/_jsx(VizExLink, {
          use: "on-bright",
          onPress: createNewThread,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-visitor-ui.network.pubSubFailure.retry"
          })
        });
      case SUBSCRIPTIONS_FAILED:
        return /*#__PURE__*/_jsx(VizExLink, {
          use: "on-bright",
          onPress: resubscribe,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-visitor-ui.network.pubSubFailure.retry"
          })
        });
      case PUBSUB_FAILED:
        return /*#__PURE__*/_jsx(VizExLink, {
          use: "on-bright",
          onPress: startPubSub,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-visitor-ui.network.pubSubFailure.retry"
          })
        });
      default:
        return null;
    }
  })();
  return /*#__PURE__*/_jsx(ChatAreaAlert, {
    title: title,
    onClose: dismissNetworkError,
    link: link
  });
};
NetworkErrorAlerts.displayName = 'NetworkErrorAlerts';
export default NetworkErrorAlerts;